// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gmJx","col":"styles_col__2T-01"};